import { useMemo } from "react";
import { randomMotionPair } from "@/lib/motion";
import MotionVideo from "@/components/MotionVideo";

// Amrita's Apple Motion Art playing softly behind a section — two pieces
// crossfading on a long, slow cycle. A fresh pair is chosen on every visit,
// so the ambience changes on its own, even on static hosting.
const MotionBackdrop = ({ dim = 0.5, className = "" }) => {
  const [a, b] = useMemo(randomMotionPair, []);
  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      <MotionVideo name={a} autoPlay className="absolute inset-0 h-full w-full object-cover opacity-50" />
      <MotionVideo name={b} autoPlay className="motion-xfade absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ background: `rgba(29,18,6,${dim})` }} />
    </div>
  );
};

export default MotionBackdrop;
